import { useInstantSearch } from "react-instantsearch";

import { useAnalytics } from "@tudigo-monorepo/web-tudigo-tracking";

import type { RefinementListItem } from "../../shared-internal/components/search-projects/custom-refinement-list";
import type { RefinementAttributeList } from "../../shared-internal/models/algolia-refinement-attributes";

export function useSearchProjectsRefinementsCustomerTracking() {
  const { results } = useInstantSearch();
  const analytics = useAnalytics();

  const trackRefinement = (
    refinementList: RefinementAttributeList,
    item: RefinementListItem,
  ) => {
    analytics.track("ui.projects_listing_page.filtered", {
      filter_category: refinementList.value,
      filter_option_selected: item.label,
      projects_count: item.count,
      projects_ongoing_count: results?.hits?.filter(
        (project) => project.status === "started",
      ).length,
    });
  };

  return { trackRefinement };
}
